export default {
  NO_ORDERS: 'Nenhum pedido no momento :(',
  NO_ORDERS_OPENED: 'Você não possui pedidos abertos.',
  NO_ORDERS_CLOSED: "Nenhum pedido finalizado no momento",
  ERROR_AWAIT: 'Algo aconteceu, por favor aguarde que logo vamos exibir os seus pedidos :)'
}
